import Enum from "../../../../../../enums/Enum";

const AlcoholUseEnum = new Enum({
    NA: {name: "N/A"},
    NONDRINKER: {name: "Non-Drinker"}
});

export default AlcoholUseEnum;